import { call, put, takeEvery } from 'redux-saga/effects'
import * as reportActions from '@redux/ducks/reportDucks'
import * as reportApi from '@api/report.Api'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListReportDetail({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof reportApi.getListReportDetail> = yield call(reportApi.getListReportDetail, queryString)
    yield put(reportActions.getListReportDetailSuccess(res))
  } catch (error) {
    yield put(reportActions.getListReportDetailFail(error))
  }
}

function* fetchListReportOrder({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof reportApi.getListReportOrder> = yield call(reportApi.getListReportOrder, queryString)
    yield put(reportActions.getListReportOrderSuccess(res))
  } catch (error) {
    yield put(reportActions.getListReportOrderFail(error))
  }
}

export default function* watchReport() {
  yield takeEvery(reportActions.getListReportDetail.toString(), fetchListReportDetail)
  yield takeEvery(reportActions.getListReportOrder.toString(), fetchListReportOrder)
}
